var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-map',{attrs:{"zoom":_vm.zoom,"center":_vm.center}},[_c('l-tile-layer',{attrs:{"url":_vm.url}}),_c('l-geo-json',{attrs:{"geojson":_vm.geojson}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }